import { Component, OnInit } from '@angular/core';
import { PlanService } from '../landing/services/plan.service';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {
  planData:any;
  selectedPlan:any;
  searchCategories:any;
  basic:boolean = false;
  advanced:boolean = false;
  pro:boolean = false;
  proPlus:boolean = false;
  elite:boolean = false;
  constructor(private planService: PlanService) { }

  ngOnInit() {
    this.getPlansSearchCategory();
  }

  getPlansSearchCategory() {
    this.planService.getPlansSearchCategory().subscribe((response: any) => {
      if (response != null && response.content != null) {
        if (response.content.planData != null && response.content.planData.length > 0) {
          this.planData = response.content.planData;
          response.content.planData.forEach(element => {
            if(element != null)
            {
               if(element.planName == 'Basic')
               {
                 this.basic = true;
               }
               if(element.planName == 'Advanced')
               {
                this.advanced = true;
               }
               if(element.planName == 'Pro')
               {
                this.pro = true;
               }
               if(element.planName == 'Pro+')
               {
                 this.proPlus = true;                 
               }
               if(element.planName == 'Elite')
               {
                this.elite = true;
               }
            }
          });
          // if (this.selectedPlan > 0) {
          //   this.planForm.controls.selectedPlan.setValue(this.selectedPlan);
          // }
        }
        if (response.content.planData != null && response.content.searchCategory.length > 0) {
          this.searchCategories = response.content.searchCategory;
        }
      } else {

      }
    });
  }

  // getPlansSearchCategory() {
  //   this.planService.getPlansSearchCategory().subscribe((response: any) => {
  //     if (response != null && response.content != null) {
  //       if (response.content.planData != null && response.content.planData.length > 0) {
  //         this.planData = response.content.planData;
        
  //       }
  //       if (response.content.planData != null && response.content.searchCategory.length > 0) {
  //         this.searchCategories = response.content.searchCategory;
  //       }
  //     } 
  //   });
  // }
}
